import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getToken } from "../utils/authUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

interface CatalogScreenProps {
  onBoxClick: () => void;
}

const CatalogScreen: React.FC<CatalogScreenProps> = ({ onBoxClick }) => {
  const navigate = useNavigate();
  const [boxCount, setBoxCount] = useState(3);
  const [searchParams] = useSearchParams();
  const [organization, setOrganization] = useState<any>(null);
  const [generalError, setGeneralError] = useState<string>("");
  const [loadingOrganization, setLoadingOrganization] = useState<boolean>(true);
  const organization_handle = searchParams.get("o");

  const handleBoxClick = (boxIndex: number) => {
    switch (boxIndex) {
      case 0:
        onBoxClick();
        break;
      case 1:
        navigate("/show-case/catalog-screen/see-catalog");
        break;
      case 2:
        navigate("/kiosksapp");
        break;
      default:
        console.log("Invalid Box Clicked");
        break;
    }
  };

  useEffect(() => {
    const updateBoxCount = () => {
      setBoxCount(window.innerWidth <= 576 ? 1 : 2);
    };

    updateBoxCount();
    window.addEventListener("resize", updateBoxCount);
    return () => window.removeEventListener("resize", updateBoxCount);
  }, []);

  const getLogo = async () => {
    if (!organization_handle) return;

    const userToken = getToken();
    setLoadingOrganization(true);

    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}api/public/organizations/${organization_handle}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      setOrganization(response.data.data);
    } catch (error) {
      console.error("Error fetching organization logo:", error);
      setGeneralError("Failed to load organization details.");
    } finally {
      setLoadingOrganization(false);
    }
  };

  useEffect(() => {
    getLogo();
    // eslint-disable-next-line
  }, [organization_handle]);

  const boxImages = [
    "/images/visualizer-screen.png",
    "/images/tiles-slider.png",
  ];

  return (
    <div className="catalog-screen">
      <div
        style={{
          margin: "20px auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "110px",
          height: "100%",
          overflow: "hidden",
        }}
      >
        {loadingOrganization ? (
          <div
            className="skeleton-catalog"
            style={{ height: "100px", width: "100px" }}
          ></div>
        ) : organization?.logo ? (
          <img
            src={organization.logo}
            alt="Organization Logo"
            className="organization-logo"
            height={"100px"}
            width={"100px"}
          />
        ) : (
          <p className="error-text">{generalError || "Logo not available"}</p>
        )}
      </div>

      {/* Catalog Boxes */}
      <div className="catalog-screen-box">
        {boxCount === 1 ? (
          <Swiper spaceBetween={20} slidesPerView={1}>
            {boxImages.map((image, index) => (
              <SwiperSlide
                key={index}
                className="d-flex justify-content-center"
              >
                <div
                  className="screen-box-1"
                  style={{
                    cursor: "pointer",
                    backgroundImage: `url(${image})`,
                  }}
                  onClick={() => handleBoxClick(index)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="d-flex justify-content-evenly">
            {boxImages.map((image, index) => (
              <div
                key={index}
                className="screen-box-1"
                style={{
                  cursor: "pointer",
                  backgroundImage: `url(${image})`,
                }}
                onClick={() => handleBoxClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CatalogScreen;
